import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      className="container terms-conditions"
      style={{ color: "black", fontSize: "16px" }}
    >
      <div className="row">
        <div className="col-12">
          <h3 style={{ fontSize: "20px" }}>
            TERMS AND CONDITIONS OF MEMBERSHIP IN CNNM MATRIMONY
          </h3>
          <p>
            Welcome to{" "}
            <a
              href="www.cnnmandram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.cnnmandram.com
            </a>{" "}
            (herein referred to as CNNMM).
          </p>
          <p>
            This document is an electronic record in terms of the Information
            Technology Act, 2000 and rules thereunder pertaining to electronic
            records as applicable and amended. This electronic record is
            generated by a computer system and does not require any physical or
            digital signatures.
          </p>
          <p>
            This document is published in accordance with the provisions of Rule
            3 (1) of the Information Technology (Intermediaries Guidelines and
            Digital Media Ethics Code) Rules, 2021 that require publishing the
            rules and regulations, privacy policy, and the terms and conditions
            for access or usage of{" "}
            <a
              href="www.cnnmandram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.cnnmandram.com
            </a>{" "}
            (the “Website”).
          </p>
          <p>
            <strong style={{ fontSize: "18px" }}>
              PLEASE READ THE FOLLOWING TERMS AND CONDITIONS VERY CAREFULLY
              BEFORE USING THE WEBSITE. ACCESSING, BROWSING OR OTHERWISE USING
              THE WEBSITE IMPLIES YOUR AGREEMENT TO BE BOUND BY ALL THESE TERMS
              AND CONDITIONS (“Agreement”).
            </strong>
          </p>
          <p>
            If you do not want to be bound by the Terms and Conditions, you must
            not use the Website or CNNM Matrimony services. The Terms and
            Conditions also include the applicable policies which are
            incorporated herein by reference and as amended from time to time
            (the “Terms and Conditions”).
          </p>
          <p>
            In these Terms, references to “CNNMM member” shall mean the end user
            accessing the Website/CNNMM services, its contents or using the
            CNNMM Services. CNNMM member also includes persons such as
            bridegroom, their mothers, sisters, relatives or friends
            (“Registrant”) of the prospective bride or bridegroom. The terms
            “You” and “User” shall be interchangeably used for CNNMM
            member/customer. Chennai Nanbargal Nala Mandram Matrimony (CNNMM) is
            a service provided by a trust under the Societies Act.
          </p>
          <h4 style={{ fontSize: "18px" }}>Scope</h4>
          <p>
            You understand and acknowledge that{" "}
            <a
              href="www.cnnmandram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.cnnmandram.com
            </a>{" "}
            Matrimony site (CNNMM) acts as an “Intermediary” as defined under
            clause (1) sub-clause (w) of Section 2 of the Information Technology
            Act, 2000. CNNMM is a brand owned by Chennai Nanbargal Nala Mandram
            (CNNM) which owns, retains and has complete rights in CNNM and the
            CNNMM Website.
          </p>
          <p>
            CNNMM acts as a platform to enable any user to register on it (by
            filling the mandatory fields and optional fields, if any) to
            voluntarily search for profile(s) from the database of CNNMM’s
            already registered users, for seeking prospective lawful matrimonial
            alliances for themselves.
          </p>
          <p>
            CNNMandram may also be able to assist you to create your profile,
            however, you must have to provide valid/operational mobile phone
            number and an email ID. The profiles in the database of CNNMM are
            classified broadly on the basis of language and region for the ease
            and convenience of its member/customer. CNNMM members are provided
            with free/paid access for searching profiles from the database of
            CNNMM as per the partner preference set by you (on the Website), and
            you can shortlist the profiles in which you are interested.
          </p>
          <h4 style={{ fontSize: "18px" }}>1. Eligibility</h4>
          <p>
            A) CNNMM membership and rights of admission are reserved solely for:
          </p>
          <ol type="I" style={{ fontSize: "16px" }}>
            <li>Indian Nationals & Citizens.</li>
            <li>Persons of Indian Origin (PIO).</li>
            <li>Non-Resident Indians (NRI).</li>
            <li>Persons of Indian Descent or Indian Heritage.</li>
            <li>Persons who intend to marry persons of Indian Origin.</li>
          </ol>
          <p>
            B) Further, in your capacity as a CNNMM member, you confirm that you
            are:
          </p>
          <ol type="I" style={{ fontSize: "16px" }}>
            <li>
              18 years or above (if you are a woman) or 21 years or above (if
              you are a man);
            </li>
            <li>
              If you have applied for divorce, you may register on our Website
              by stating “Awaiting Divorce”;
            </li>
            <li>
              If you are a resident of any other country, you are legally
              competent to marry as per the local rules applicable in your
              country and shall comply with the Indian laws for marrying a
              person of Indian origin.
            </li>
          </ol>
          <p>
         In case you are a Registrant of the prospective bride/bridegroom
            and have created a profile in the CNNMM Website on their behalf or
            are accessing the CNNMM Website on behalf of them, it is implied
            that you have taken their consent for their profile creation in
            CNNMM and for accessing the CNNMM Website.
          </p>
          <h4 style={{ fontSize: "18px" }}>2. Registration</h4>
          <p>
            A) CNNMM expects you to complete the online registration process
            with fairness and honesty by furnishing true, accurate, current, and
            complete information, along with providing recent photographs of
            yourself to help meet your partner preferences.
          </p>
          <p>
            You are advised to carefully read the relevant sections before
            entering details or uploading your photo.
          </p>
          <p>
            You must not enter details of the profile in fields other than the
            applicable ones (for example, refraining from entering ID numbers
            from other platforms/websites/apps or repeating your details in
            unrelated fields).
          </p>
          <p>
            Information should only be filled in the relevant sections or
            photograph fields.
          </p>
          <p>
            In case CNNMM requires additional details to better serve you, you
            agree to provide such information. Optionally, you may provide a
            valid contact number of our retail outlet partners for callback and
            assistance in completing your profile registration.
          </p>
          <p>
            You may also enter your email ID and phone number in any CNNMM
            registration campaigns or advertisements on various websites. Based
            on such campaigns, you may receive a call from the CNNMM Customer
            Support to assist with completing your registration.
          </p>
          <p>
            CNNMM may also reproduce your profile information on other
            matrimonial websites owned by the Trust (including community-based
            websites) to better match profiles for you.
          </p>
          <p>
            B) If, at any time, CNNMM becomes aware (or is informed by a third
            party) that any information you have provided during registration
            (including photos) is untrue, inaccurate, or incomplete, CNNMM shall
            have the full right to:
          </p>
          <ol type="I" style={{ fontSize: "16px" }}>
            <li>Suspend or terminate your CNNMM membership without notice;</li>
            <li>Forfeit any amount paid toward CNNMM membership;</li>
            <li>Refuse to provide CNNMM services to you thereafter.</li>
          </ol>
          <p>
            C) CNNMM also reserves the right to block your profile registration
            on the Website if your contact details or links are found in
            irrelevant fields, or if there are errors in any data entered by
            CNNMM members in their profile.
          </p>
          <p>
            D){" "}
            <strong style={{ fontSize: "18px" }}>
              Duplicate Profile Restriction
            </strong>
            <br />
            Registration of duplicate profiles of the same individual is
            strictly prohibited on the CNNMM Matrimony Website/App. CNNMM
            reserves the full right to suspend or terminate such duplicate
            profiles without prior notice.
          </p>
          <p>
            E){" "}
            <strong style={{ fontSize: "18px" }}>
              Intent and Eligibility for Registration
            </strong>
            <br />
            By registering with CNNMM Matrimony, you confirm that your intention
            is bona fide and strictly for the purpose of marriage.
            <br />
            CNNMM Matrimony membership is meant solely for individual use.
            <br />
            Organizations, businesses, and individuals involved in matrimonial
            or similar/commercial services are not permitted to register or use
            CNNMM Matrimony services or member data for any commercial purposes.
            <br />
            CNNMM reserves the right to initiate legal action for any breach of
            these conditions.
          </p>
          <h4 style={{ fontSize: "18px" }}>3. Account Security</h4>
          <p>
            You are solely responsible for maintaining the confidentiality of
            your CNNMM login credentials, including your user ID, password, and
            OTP, and for restricting unauthorized access to your device.
          </p>
          <p>
            CNNMM will never request your password. You are strongly advised not
            to share your password or credentials with anyone.
          </p>
          <p>
            You agree to take full responsibility for all activities that occur
            under your account.
          </p>
          <h4 style={{ fontSize: "18px" }}>
            4. Role and Responsibility of CNNMM Matrimony
          </h4>
          <p>
            A) CNNMM reproduces and displays your profile information in its
            original form ("as is, as available") once you register on the
            Website. Your profile may also be shared across other matrimonial
            platforms operated by the Trust to maximize compatibility and
            matching options.
          </p>
          <p>
            B) CNNMM Matrimony acts solely as a platform for registered members
            to independently search for potential life partners. The platform
            does not offer matchmaking services or personal assistance.
          </p>
          <p>
            C) Match results displayed are automatically generated based on the
            partner preferences you provide. If you update your preferences, the
            results will change accordingly.
          </p>
          <p>
            D) CNNMM does not restrict members from expressing interest in your
            profile based on their preferences. However, you are free to accept,
            reject, or ignore such interests at your own discretion.
          </p>
          <p>
            E) CNNMM does not assure or take responsibility for the success of
            any match or outcome resulting from the use of its services or any
            affiliated community-based platforms.
          </p>
          <p>
            F) CNNMM ensures reasonable measures to protect sensitive user data
            through encryption, authentication, and access controls.
          </p>
          <p>
            G) While CNNMM employs standard security protocols, it cannot fully
            guarantee the protection of data in transit or prevent tampering by
            malicious third parties before data reaches our servers.
          </p>
          <p>
            H) For enhanced privacy and safety, CNNM Matrimony offers a
            dedicated feature for women members called Secure Connect. This
            enables women to receive calls from premium male members without
            disclosing their contact numbers. It is solely the woman’s choice to
            respond, and CNNMM holds no control over such interactions.
          </p>
          <p>
            I) CNNMM does not verify or endorse the authenticity of any profile
            information. It is the responsibility of each member to
            independently verify the credentials and details of other users
            before proceeding further.
          </p>
          <p>
            A) Members are advised to protect their account by setting a strong
            password during profile creation. A strong password must include a
            mix of uppercase and lowercase letters along with numbers.
          </p>
          <p>
            B) Any personal or profile-related information requested by CNNMM
            for continued access to its services must be provided by the member
            promptly and accurately.
          </p>
          <p>
            C) It is the sole responsibility of each member to verify the
            credentials and background of prospective matches. This includes
            marital status, educational qualifications, financial status,
            occupation, character, and health conditions. CNNMM will not be held
            liable for any misrepresentation or misinformation provided by
            members.
          </p>
          <p>
            D) Members must exercise due diligence and verify the authenticity
            of a prospect before engaging in video interactions. CNNMM shall not
            be responsible for any misconduct or false claims during such
            interactions.
          </p>
          <p>
            E) Members are encouraged to upload a recent photograph (taken
            within the last three months) for better search visibility.
            Uploading outdated images, images of others, or providing false or
            misleading information is considered a violation of CNNM Matrimony’s
            terms. Appropriate action will be taken as per Clause 2(b).{" "}
          </p>
          <p>
            F) Members must disclose relevant health information at the time of
            registration, including any existing health conditions or physical
            disabilities. Non-disclosure will be treated as a breach of terms,
            and CNNMM reserves the right to act under Clause 2(b).
          </p>
          <p>
            G) CNNMM Members are strictly advised to refrain from the following:
          </p>
          <ul>
            <li>
              Engaging in any financial transactions with prospects. Do not
              request or offer financial help.
            </li>
            <li>Using disrespectful or abusive language in communication.</li>
            <li>Making discriminatory or racially insensitive remarks</li>
            <li>
              Sharing confidential personal information, including bank details
              or sensitive documents.
            </li>
            <li>Establishing physical relationships before marriage.</li>
            <li> Violating any applicable law.</li>
            <li>
              Referring to or promoting other matrimonial platforms in personal
              messages.
            </li>
          </ul>
          <p>
            {" "}
            H) Members are encouraged to stay informed on online safety and
            partner search precautions. A dedicated safety resource will be
            provided on CNNM Matrimony’s official site to guide members with
            secure usage practices.{" "}
          </p>
          <p>
            I) Members must remain cautious of suspicious behavior such as
            repeated requests for money, communication from multiple phone
            numbers, or a reluctance to meet in person. Such conduct should be
            treated with care and reported if necessary, Members should be alert
            if a prospect avoids meeting (either in person or through video
            calls), does not involve family or friends in the matchmaking
            process, or behaves suspiciously. Always check whether the
            prospect’s profile is active or suspended before proceeding further.
          </p>
          <p>
            J) To receive better search results, members are encouraged to log
            in regularly and use features such as expressing interest. Free
            members may send system-generated expressions of interest, while
            premium members can send personalized messages. Members are advised
            to check and respond to the expressions of interest or messages
            received from prospects.
          </p>
          <p>
            K) By using CNNM Matrimony’s Website/App, you agree to abide by its
            terms and conditions while using features such as chat, horoscope
            viewing, privacy controls (like restricting access to photo,
            horoscope, or contact number), and viewing publicly available social
            and professional profiles (e.g., Facebook, LinkedIn).
          </p>
          <p>
            L) Members are required to keep their profile information up to
            date. Failure to do so may lead to suspension of membership at the
            discretion of CNNM Matrimony.
          </p>
          <p>
            M) Once your marriage is finalized, you are expected to either
            delete your profile yourself or inform CNNM Matrimony to remove it
            from the platform.{" "}
          </p>
          <p>
            N) Members should use secure devices and private networks when
            accessing CNNM Matrimony to ensure safety and privacy.
          </p>
          <p>
            O) The use of any automated tools, bots, scripts, or programs to
            browse, communicate, or interact on the CNNMM platform is strictly
            prohibited.
          </p>
          <p>
            P) Members are forbidden from attempting to breach or test the
            security of the CNNMM platform or any connected network.
          </p>
          <p>
            Q) Payments must be made to CNNM Matrimony’s authorized account
            only. No payments should be transferred to any CNNM/CNNMM staff
            members and Office Bearers or representative personally.
          </p>
          <p>
            R) Members are encouraged to contact CNNM Matrimony directly to
            resolve any concerns or complaints. Publicairing of grievances,
            including on social media, is strongly discouraged.
          </p>
          <h4 style={{ fontSize: "18px" }}>6. Customer Support</h4>
          <p>
            For any assistance, queries, or concerns related to CNNM Matrimony,
            you may contact: Email: admin@cnnmandram.com <br />
            Phone: 044-2432 2858, Whatsapp: 94459 43929 <br />
            Address: <br />
            Chennai Nanbargal Nala Mandram, No.39/22, Pillaiyar Koil Street,
            Saidapet, Chennai-600 015. <br />
          </p>
          <h4 style={{ fontSize: "18px" }}>
            7. Medium of Communication to CNNMM Members
          </h4>
          <p>
            By registering, members consent to receive communications from CNNM
            Matrimony, including service updates and promotional messages,
            through multiple channels such as email, phone calls, SMS, and
            WhatsApp. These may also come from CNNMM’s trusted partners or
            associated platforms.
          </p>
          <p>
            B) CNNM Matrimony may send you profiles of suitable matches via
            images, messages, documents, or links through its automated systems.
            By submitting your mobile number(s) for verification, you confirm
            that the number is not listed under the Do Not Disturb (DND) or
            National Customer Preference Register (NCPR). Even if your number is
            registered under DND/NCPR, you agree that calls from CNNM Matrimony
            to your verified or alternative numbers shall not be treated as
            promotional in nature.
          </p>
          <p>
            C) You may choose how often you want to receive communication from
            CNNM Matrimony, such as weekly or fortnightly. You may also opt out
            of receiving calls from CNNMM by selecting the appropriate option in
            your account settings. However, you acknowledge that relationship
            managers from services like Assisted or Elite Matrimony may still
            contact you if your profile is shortlisted by a premium member.
          </p>
          <h4 style={{ fontSize: "18px" }}>8. Confidentiality</h4>
          <p>
            Any feedback or suggestions you provide to CNNM Matrimony shall be
            treated as non confidential. CNNMM shall have the unrestricted right
            to use such feedback. By submitting feedback, you confirm that:
          </p>
          <ul>
            <li>
              (i) It does not include confidential or proprietary information of
              yourself or third parties;
            </li>
            <li>
              (ii) CNNMM is not obligated to maintain confidentiality with
              respect to the feedback;
            </li>
            <li>
              (iii) You are not entitled to any compensation for the feedback
              under any circumstances.
            </li>
          </ul>
          <h4 style={{ fontSize: "18px" }}>9. Privacy of Membership</h4>
          <p>
            {" "}
            To Protect your privacy and understand our practices as amended from
            time to time, please read and follow our privacy policy which also
            governs your visit CNNM to understand how we collect, use, and
            protect your personal information. By using the CNNMM platform, you
            agree that:{" "}
          </p>
          <p>
            Your data will be treated confidentially in accordance with our
            Privacy Policy and applicable laws;
          </p>
          <p>
            If you do not agree with the use or transfer of your information as
            described, you should discontinue use of the platform.
          </p>
          <h4 style={{ fontSize: "18px" }}>10. Grievance Officer </h4>
          <p>
            If you observe any violations or offensive content on CNNM
            Matrimony, such as impersonation, copyright issues, obscene or
            harmful materials, or any other form of misconduct, please report
            them in writing or via email (with digital signature if applicable)
            to:
          </p>
          Email: admin@cnnmandram.com Contact Address: The Secretary of Chennai
          Nanbargal Nala Mandram
          <p>
            The Secretary is available from 10:00 a.m. to 05.30 p.m. IST, Sunday
            to Saturday (except Tuesday and public holidays), and functions as
            per Rule 3(11) of the Information Technology (Intermediary
            Guidelines) Rules, 2011. All complaints must be submitted in
            writing.
          </p>
          <p>
            The Secretary shall address complaints pertaining to any violation
            of acceptable usage of the Website. Members shall not host, upload,
            modify, transmit, publish, or share any information on CNNM
            Matrimony that:
          </p>
          <ol  >
            <li>A, Belongs to another person without proper authorization;</li>
            <li>B, Is obscene, pornographic, pedophilic, invasive of privacy (including bodily privacy), or
              harasses/insults based on gender, race, caste, religion, or ethnicity; or promotes money
              laundering, gambling, or incites violence or enmity;</li>
            <li>C, Is harmful to children;</li>
            <li>D, Infringes intellectual property rights including patents, trademarks, or copyrights;</li>
            <li>E, Is intended to deceive, mislead, or knowingly transmit false or misleading information;</li>
            <li>F, Involves impersonation of another person;</li>
            <li>G, Threatens the unity, integrity, defense, security, or sovereignty of India, disturbs public order,
              or insults foreign nations;</li>
            <li>H, Contains malicious software, viruses, or any program that harms or limits functionality of
              computer resources;</li>
            <li>I, Violates any prevailing law.</li>
          </ol>

          <h4 style={{ fontSize: '18px' }}>11. Disputes Between Members</h4>
          <p>A) CNNM Matrimony members are solely responsible for their communication, transactions, and
            interactions with one another, whether through the platform (Website) or any other medium (e.g.,
            email, chat, WhatsApp, phone calls). CNNMM does not take responsibility for any monetary
            transactions, personal exchanges, or misuse of information among members.</p>
          <p>B) CNNM Matrimony has no obligation to monitor or mediate disputes between members and will
            not be a party to any conflict, litigation, or grievance arising out of member interactions.</p>
          <p>C) CNNM Matrimony is not a broker or agent for any member. The organization does not facilitate
            or involve itself in member discussions, nor does it influence or guarantee the outcomes of such
            conversations.</p>

          <h4 style={{ fontSize: '18px' }}>12. Content Rights</h4>
          <p>A) All content displayed on CNNM Matrimony, excluding content uploaded by users or third parties
            (such as advertisements), is the property of Chennai Nanbargal Nala Mandram or its licensed
            partners. The platform holds the rights to display such content on the Website.</p>
          <p>B) Members are solely responsible for the accuracy, legality, and ownership of the content they
            upload-including personal details, photographs, and any optional or mandatory profile
            information. CNNM Matrimony is not liable for any content misrepresentation or consequences
            arising from member-generated content.</p>
          <p>C) CNNM Matrimony does not assume the obligation to monitor user-generated content.
            However, any content that is found to violate these Terms and Conditions may be removed, and
            the associated profile may be suspended or permanently deleted without refund. CNNM
            Matrimony reserves the right to restrict any member’s communication privileges if deemed
            necessary.</p>
          <p>D) CNNM (Chennai Nanbargal Nala Mandram) reserves the right to take appropriate legal action
            against any user who infringes its proprietary rights or unlawfully copies, modifies, publishes,
            transmits, or uses its content for commercial or unauthorized purposes.</p>

          <h4 style={{ fontSize: '18px' }}>13. Third-Party Websites and Services</h4>
          <p>A) Members acknowledge that CNNM Matrimony may display third-party advertisements or
            include links to external websites on its platform. These third-party websites are governed by their
            own terms of use and privacy policies. CNNMM does not verify, endorse, or authenticate the
            contents of such third-party websites, and users access them entirely at their own risk.</p>
          <p>B) CNNM Matrimony may also facilitate third-party services (e.g., horoscope matching) through
            its platform. Payments collected for such services may be subject to revenue-sharing
            arrangements with the service providers. CNNMM shall not be held responsible or liable for the
            performance, accuracy, or reliability of any third-party service.</p>
          <p>C) CNNMM reserves the right to modify, suspend, or discontinue any part of the Matrimony
            services without prior notice. Members are expected to stay updated by regularly checking the
            Website.</p>

          <h4 style={{ fontSize: '18px' }}>14. Limitation of Liability</h4>
          <p>A) CNNMM (including its office bearers, administrators, or affiliates) shall not be held liable under
            any circumstances for any direct, indirect, incidental, special, exemplary, or consequential
            damages incurred by members or third parties. This includes damages resulting from the use or
            inability to use the CNNM Matrimony Website, third-party websites, or services provided through
            the platform.</p>
          <p>B) CNNM Matrimony clarifies that the exchange of member profiles via its platform shall not, under
            any circumstances, be interpreted as a matrimonial offer, recommendation, advice, or guarantee
            from CNNMM.</p>
          <p>C) Notwithstanding any other provision herein, the liability of CNNM Matrimony, if any, shall be
            limited strictly to the amount paid by the member for a specific paid package. No further claim
            shall be entertained under any circumstances.</p>
            <h4 style={{ fontSize: '18px' }}>15. Match Availability Disclaimer</h4>
          <p>CNNMM shall not be held liable for any unsuitable or improper matches resulting from the
            unavailability of profiles, including those from its affiliated platforms or services.</p>

          <h4 style={{ fontSize: '18px' }}>16. Financial Transactions</h4>
          <p>CNNMM and its office bearers shall not be responsible for any financial transactions undertaken
            between members or between a member and any third party.</p>

          <h4 style={{ fontSize: '18px' }}>17. Communication Responses</h4>
          <p>CNNMM shall not be held liable if a member does not respond or reciprocate communication
            initiated for matrimonial purposes.</p>

          <h4 style={{ fontSize: '18px' }}>18. Class Action Waiver</h4>
          <p>Members agree not to initiate or participate in any class action lawsuit or class arbitration in
            connection with any dispute involving CNNM Matrimony.</p>

          <h4 style={{ fontSize: '18px' }}>19. False Complaints</h4>
          <p>If a member files a false or malicious complaint resulting in the suspension or deletion of another
            profile, CNNMM reserves the right to take legal action-civil or criminal-and claim any costs or
            damages incurred. Additionally, such member’s profile may be suspended, and all paid amounts
            forfeited as per Clause 2(b) of these terms.</p>

          <h4 style={{ fontSize: '18px' }}>20. Content Removal and Profile Suspension</h4>
          <p>CNNMM reserves the right to delete or modify any profile or content found to be:</p>
          <ol type="I" style={{ fontSize: '16px' }}>
            <li>Lacking proper consent,</li>
            <li>Factually inaccurate,</li>
            <li>In violation of prevailing laws,</li>
            <li>Offensive, abusive, or harmful in nature (including vulgar, defamatory, or discriminatory content),</li>
            <li>Used to harass or threaten CNNMM employees or other members,</li>
            <li>Used to send unsolicited or misleading messages referencing other matrimonial platforms.</li>
          </ol>
          <p>The platform may also block or suspend offending profiles to protect the interests and safety of
            its users and staff.</p>

          <h4 style={{ fontSize: '18px' }}>21. Expired Membership Access</h4>
          <p>Upon expiry of a paid membership, any unused call or SMS credits will not remain accessible.
            Additionally, access to previously viewed contact information will be restricted unless the
            membership is renewed within 30 days.</p>

          <h4 style={{ fontSize: '18px' }}>22. Credit Rollover</h4>
          <p>If a member renews the membership within 30 days of expiry, any unused call or SMS credits
            from the previous subscription will be carried forward.</p>

          <h4 style={{ fontSize: '18px' }}>23. Precedence in Case of Conflict</h4>
          <p>In the event of a conflict between the terms and conditions of CNNM Matrimony and those of any
            other website or affiliated platform, the terms specific to CNNM Matrimony shall prevail for
            services accessed through this platform.</p>

          <h4 style={{ fontSize: '18px' }}>24. Disclaimer</h4>
          <p>A) Your access to and use of CNNM Matrimony services, including any content, features, or
            communication tools, is entirely at your own risk. YOU UNDERSTAND AND AGREE THAT THE
            SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. To the maximum
            extent permitted by law, CNNMM DISCLAIMS ALL WARRANTIES—EXPRESS OR IMPLIED—
            INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR
            A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. CNNMM does not warrant that the
            platform, its servers, or any communications (including emails) are free from viruses or other
            harmful components. CNNMM shall not be held liable for any damages of any kind—direct,
            indirect, incidental, punitive, or consequential—arising from your use of the website or app.</p>
          <p>B) CNNMM makes no express or implied guarantee or warranty that registration and use of its
            services-whether paid or free-will result in a successful marriage or alliance.</p>
          <p>C) Notwithstanding any provisions to the contrary, CNNMM shall not be held liable under any
            circumstances for the following:</p>
          <ol type="I" style={{ fontSize: '16px' }}>
            <li>Any action or omission on the part of CNNMM, its affiliates, payment gateways, or service
              partners;</li>
            <li>Any false, misleading, or inaccurate information submitted by you or on your behalf;</li>
            <li>Any personal decision or consequence arising from your interaction with another member
              (including outcomes following profile deletion/suspension);</li>
            <li>Any unauthorized or unlawful act by any third party with regard to your data;</li>
            <li>Any cybercrime or attempted cybercrime by any individual;</li>
            <li>Events classified as force majeure or ‘acts of God’;</li>
            <li>Any matter already covered under these Terms and Conditions, including but not limited
              to the Limitation of Liability clause;</li>
            <li>Use of third-party services such as horoscope matching or related services, even when
              accessed or paid for via the CNNMM platform;</li>
            <li>Outcomes from meetings, messages, calls, chats, emails, or social media interactions with
              other members;</li>
            <li>Technical failures or issues including but not limited to telecom network issues, software
              or hardware malfunctions, system congestion, denial of service, or any disruption caused
              by spam or related activities.</li>
          </ol>
          <p>D) By continuing to use CNNM Matrimony, you expressly agree that the use of this Website is at
            your sole and exclusive risk.</p>
          <p>E) CNNMM shall not be held liable for any damage or alteration to your devices-including
            computers, mobile phones, tablets, or any related hardware or software-resulting from the
            installation or usage of the CNNMM platform or associated applications.</p>

          <h4 style={{ fontSize: '18px' }}>25. Indemnity</h4>
          <p>By registering with and using CNNM Matrimony services, you agree to defend, indemnify, and
            hold harmless CNNMM, its affiliates, trustees, executive members, administrators, agents,
            volunteers, and employees from and against any loss, damage, liability, claim, or demand—
            including reasonable legal fees—arising out of your misuse of the services or violation of these
            Terms and Conditions. This indemnity obligation will survive perpetually, even after termination
            of your membership.</p>

          <h4 style={{ fontSize: '18px' }}>26. Termination</h4>
          <p>A) CNNMM reserves the right to suspend, delete, or permanently terminate your membership at
            its sole discretion, without prior notice, in good faith and in accordance with Clause 2 (b), in any
            of the following circumstances:</p>
          <ol type="I" style={{ fontSize: '16px' }}>
            <li>If you solicit financial or physical favours from other registered members;</li>
            <li>If you have submitted false, misleading, or inaccurate information during registration or
              while using the platform;</li>
            <li>If you have engaged in fraudulent, unlawful, or illegal activities through the platform;</li>
            <li>If you have violated any of the terms outlined in these Terms and Conditions;</li>
            <li>If you have impersonated another individual or used third-party photographs, names,
              contact details, or personal data without proper authorization or consent, or engaged in
              any indecent or improper conduct with members or CNNMM volunteers/employees.</li>
          </ol>
          <p>B) In case of any complaints received against your profile, and if CNNMM decides to suspend or
            delete your profile in good faith, CNNMM shall not be held liable for any loss, cost, consequence,
            or damage incurred by you as a result of such action.</p>
          <p>C) Unless otherwise stated in these Terms and Conditions, your CNNM Matrimony membership
            may be terminated either by you or by CNNMM by giving seven (7) days written notice, without
            providing any reason. All fees or payments made until the date of termination shall be forfeited.</p>
          <p>D) Upon termination or suspension of your membership, your access to CNNM Matrimony
            services shall cease immediately. However, all clauses of this agreement that are intended to
            survive termination—such as limitations of liability and disclaimers—shall remain in full force and
            effect. Termination will not relieve you of any obligations arising before the date of termination.</p>

          <h4 style={{ fontSize: '18px' }}>27. Jurisdiction and Applicable Law</h4>
          <p>A) All services offered by CNNM Matrimony are deemed to have been entered into within the
            territorial jurisdiction of Chennai, Tamil Nadu, India.</p>
          <p>B) All disputes or claims arising out of or in connection with CNNM Matrimony shall be governed
            by the laws of India. The parties unconditionally submit to the exclusive jurisdiction of courts
            located in Chennai, Tamil Nadu, India, for the resolution of any legal matters.</p>

          <h4 style={{ fontSize: '18px' }}>28. Mode of Payment</h4>
          <p>A) Payments made through cash, cheque, net banking, debit/credit cards, UPI, RTGS, NEFT, or
            any other permitted method shall be governed by prevailing Reserve Bank of India (RBI)
            guidelines. Activation of any paid services will be subject to the successful realization of the
            payment. In case of dishonour of cheque or demand draft, the concerned member shall be liable
            to bear applicable bank charges for cheque/DD bouncing. CNNM Matrimony services may be
            suspended until the full settlement of dues and charges is made in cash.</p>
          <p>B) CNNM Matrimony may use third-party payment gateways to process online payments through
            cards or other instruments.</p>

          <h4 style={{ fontSize: '18px' }}>29. Refund and Assignment</h4>
          <p>A) All membership payments, including renewals or auto-renewals, are strictly non-refundable.</p>
          <p>B) Membership with CNNM Matrimony is non-transferable. Any attempt to assign or transfer your
            membership to another person or entity will be treated as a violation of these Terms and
            Conditions, and CNNMM reserves the right to take appropriate action under Clause 2 (b).</p>
          <p>C) Payments once made cannot be adjusted or reassigned to another person or applied towards
            other products or services offered by CNNMM or its affiliates.</p>

          <h4 style={{ fontSize: '18px' }}>30. Renewal</h4>
          <p>A) All paid memberships are automatically renewed prior to their expiration date. You agree that
            your account will be subject to this auto-renewal feature unless explicitly cancelled.</p>
          <p>B) Upon first subscription to a paid membership, you acknowledge and accept that the
            membership will automatically renew at the duration and price previously agreed upon.</p>
          <p>C) The maximum validity period of any membership package shall be twelve (12) months. Each
            package must be renewed separately upon expiration, subject to the terms applicable at that time.</p>
          <p>D) If you wish to cancel your auto-renewal, you must initiate the cancellation prior to the renewal
            date. Cancellation requests can be sent to: <a href="mailto:cancellation@cnnmmmatrimony.com">cancellation@cnnmmmatrimony.com</a></p>

          <h4 style={{ fontSize: '18px' }}>31. Additional Terms and Conditions Applicable to Non-Resident Indian (NRI) Members</h4>
          <p>A) Jurisdiction<br />
            All services offered to NRI members shall be governed by the laws of India.</p>
          <p>B) Arbitration of Disputes<br />
            Parties agree to make all reasonable efforts to resolve disputes amicably and informally through
            mutual discussions. CNNMM encourages informal resolution of disagreements prior to invoking
            any formal dispute resolution process.</p>
          <p>C) Exclusion for Intellectual Property Disputes<br />
            Notwithstanding the foregoing, any dispute relating to the infringement or violation of CNNMM’s
            intellectual property rights may, at CNNMM's discretion, be pursued through means other than
            arbitration, including but not limited to judicial proceedings.</p>
          <p>D) Renewal Pricing for NRI Members<br />
            Upon renewal, NRI members will be charged the prevailing market price of the membership
            package, regardless of any previous pricing. Renewals shall be valid for a fixed term of three (3)
            months only, irrespective of the duration of the earlier subscription.</p>
          <p>E) Enforcement of Arbitration<br />
            Any legal proceedings to enforce this arbitration clause shall be initiated exclusively in the
            competent courts located in Chennai, Tamil Nadu, India.</p>

          <h4 style={{ fontSize: '18px' }}>32. Roles & Responsibility of Customer</h4>
          <p>a. CNNM Matrimony strictly prohibits any form of discrimination against service representatives,
            including—but not limited to—discrimination based on race, religion, caste, gender, age, or any
            other characteristic protected under applicable laws.</p>
          <p>b. Customers are expected to treat all service agents with courtesy and respect. CNNMM reserves
            the right to suspend or withhold services if a customer's conduct toward any of its service
            representatives is deemed disrespectful, abusive, inappropriate, or unlawful.</p>
          <p>c. Customers are strictly prohibited from making any direct financial transactions to
            representatives of CNNMM or its service providers. All payments must be made only through the
            official channels as communicated.</p>

          <h4 style={{ fontSize: '18px' }}>33. Privacy</h4>
          <p>To understand how CNNMM collects, uses, and protects your personal information, users are
            requested to carefully read our Privacy Policy, which governs the use of CNNM Matrimony’s
            website and mobile applications. The personal information provided by you during registration or
            usage will be treated as confidential and in accordance with our Privacy Policy and applicable
            legal provisions.</p>
          <p>If you do not agree with the use or transfer of your information as stated therein, you are advised
            not to use the platform.</p>

          <h4 style={{ fontSize: '18px' }}>34. Complaints</h4>
          <p>If you have any complaints, concerns, or disputes, please contact our Secretary through a written
            application.</p>
          <p>Grievance Officer: The Secretary<br />
            Email: <a href="mailto:admin@cnnmandram.com">admin@cnnmandram.com</a><br />
            Postal Address:<br />
            The President/Secretary,<br />
            Chennai Nanbargal Nala Mandram,<br />
            No.39/22, Pillaiar Koil Street,<br />
            Saidapet, Chennai-600 015.</p>
          <p>The Grievance Officer is available between 10.00 AM and 05.00 PM IST, Sunday to Saturday
            (excluding Tuesdays and public holidays). The appointment is in accordance with Rule 3(11) of
            the Information Technology (Intermediary Guidelines) Rules, 2011. All complaints must be
            submitted in writing. We strive to address and resolve all concerns promptly and fairly.</p>

          <h4 style={{ fontSize: '18px' }}>35. Indemnity</h4>
          <p>By using CNNM Matrimony services, you agree to defend, indemnify, and hold harmless CNNMM,
            its parent company, Office Bearers and other partners from and against any loss, damage,
            liability, claim, or demand—including reasonable attorney’s fees—arising out of or in connection
            with:</p>
          <ol type="I" style={{ fontSize: '16px' }}>
            <li>Your use or misuse of the platform,</li>
            <li>Any breach of these Terms and Conditions, or</li>
            <li>Any violation of applicable laws or rights of third parties.</li>
          </ol>
          <p>This indemnification obligation shall survive the termination or expiry of your membership and
            usage of CNNM Matrimony services. This indemnity includes, but is not limited to, reasonable
            attorney’s fees, arising from any claim or demand made by any third party due to or resulting from
            improper or unauthorized use of the CNNM Matrimony services.</p>
          <p>This defense and indemnification obligation shall survive in perpetuity, even after the termination
            or expiration of your membership.</p>

          <h4 style={{ fontSize: '18px' }}>37. Termination</h4>
          <p>CNNM Matrimony reserves the right to terminate or suspend your membership at any time,
            without notice, for any violation of these Terms and Conditions. Upon such termination:</p>
          <ol type="I" style={{ fontSize: '16px' }}>
            <li>All amounts paid by you till the date of termination shall be forfeited.</li>
            <li>Your right to access the CNNM Matrimony website, mobile application, or related services shall
              cease immediately.</li>
            <li>Any obligations, disclaimers, indemnities, or limitations of liability that are inherently intended to
              survive termination shall remain in full effect.</li>
            <li>Termination of your access does not relieve you of any obligations that may have arisen prior to
              such termination.</li>
          </ol>

          <h4 style={{ fontSize: '18px' }}>38. Governing Laws</h4>
          <p>These Terms and Conditions shall be exclusively governed by and interpreted in accordance with
            the laws of India. Any disputes arising under these terms shall be subject to the jurisdiction of the
            courts in Chennai, Tamil Nadu, India.</p>

          <h4 style={{ fontSize: '18px' }}>39. Arbitration of Disputes</h4>
          <p>In the event of any dispute, both parties shall first attempt to resolve the issue amicably and
            informally through mutual discussion. If the dispute remains unresolved after 30 (thirty) days from
            the initial notice of dispute, it shall be referred to individual arbitration under the provisions of the
            Arbitration and Conciliation Act, 1996.</p>
          <p>The seat of arbitration shall be Chennai, Tamil Nadu, India.</p>
          <p>The proceedings shall be conducted in the English language.</p>
          <p>CNNM Matrimony shall appoint the sole arbitrator.</p>
          <p>This arbitration clause shall not apply to matters relating to intellectual property infringement,
            which CNNMM reserves the right to pursue through other legal remedies.</p>
       

        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
